import { render } from "./lightbox.html?vue&type=template&id=8dd1a2c6&ts=true"
import script from "./lightbox.vue?vue&type=script&lang=ts"
export * from "./lightbox.vue?vue&type=script&lang=ts"

import "./lightbox.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__